export default __webpack_public_path__ + "static/media/crysta_bliss.a080824a.png";